module.exports = __webpack_public_path__ + "static/media/template7.2a9ca73d.png";